import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    loginButton: {
        innerHTML: "Suivant"
    },
    codeButton: {
        innerHTML: "Connexion"
    },
    loginInProgress: "Connexion en cours...",
    loginInput: {
        placeholder: "Identifiant"
    },
    passwordInput: {
        placeholder: "Code d'identification"
    },
    infoConnection: {
        mail: "Veuillez entrer votre adresse e-mail",
        code: "Veuillez entrer le mot de passe envoyé à votre adresse e-mail"
    },
    connection: "Connexion",
    mailTitle: "Adresse mail :",
    codeTitle: "Mot de passe"
};

export type I18nLoginPage = typeof _fr;

const _en: I18nLoginPage = {
    loginButton: {
        innerHTML: "Next"
    },
    codeButton: {
        innerHTML: "Connection"
    },
    loginInProgress: "Connecting...",
    loginInput: {
        placeholder: "Login"
    },
    passwordInput: {
        placeholder: "Connection code"
    },
    infoConnection: {
        mail: "Please enter your e-mail address",
        code: "Please enter the password sent to your e-mail address"
    },
    connection: "Connection",
    mailTitle: "E-mail address :",
    codeTitle: "Password"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nLoginPage {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}